// extracted by mini-css-extract-plugin
export default {"alertsContainer":"AlertsModal_alertsContainer__XllW7"};